import { __rest } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { apiHolder as api, apis } from 'api';
import debounce from 'lodash/debounce';
import { useAppSelector } from '@web-common/state/createStore';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const storeApi = api.api.getDataStoreApi();
const HOCEditorUploadPlaceholder = (Component) => {
    const UploadPlaceholder = props => {
        const { forwardedRef, onEditCreated } = props, rest = __rest(props, ["forwardedRef", "onEditCreated"]);
        const writeLetterProp = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.writeLetterProp; });
        const currentMail = useAppSelector(state => state.mailReducer.currentMail);
        const currentMailId = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.cid; });
        const writeLetterPropRef = useRef('');
        const writeFromRef = useRef('');
        const [editorInstance, seteditorInstance] = useState(null);
        const showPlaceholderByWriteType = debounce(() => {
            var _a;
            if (!editorInstance)
                return;
            let showPlaceholder = true;
            if (['editDraft', 'edit'].includes(writeLetterPropRef.current) ||
                ['template'].includes(writeFromRef.current) ||
                currentMail.extraOperate === 'questionApply' ||
                ((_a = currentMail.entry) === null || _a === void 0 ? void 0 : _a.withoutPlaceholder)) {
                showPlaceholder = false;
            }
            const defaultDir = storeApi.getSync('defaultDir').data;
            editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.fire('updatePlaceholder', { show: showPlaceholder, dir: defaultDir });
        }, 300);
        useEffect(() => {
            writeLetterPropRef.current = writeLetterProp;
            writeFromRef.current = currentMail.form;
            if (editorInstance) {
                editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.fire('recoverSplitIcon');
                showPlaceholderByWriteType();
            }
        }, [writeLetterProp, currentMailId, editorInstance]);
        const editorSetup = ed => {
            seteditorInstance(ed);
            onEditCreated(ed);
        };
        return React.createElement(Component, Object.assign({}, rest, { onEditCreated: editorSetup, ref: forwardedRef }));
    };
    return React.forwardRef((props, ref) => React.createElement(UploadPlaceholder, Object.assign({}, props, { forwardedRef: ref })));
};
export default HOCEditorUploadPlaceholder;
